<template>
  <div class="mobile-small-layout">
    <!-- 头部标题区域 -->
    <header class="screen-header">
      <div class="header-content">
        <div class="logo-section">
          <img src="@/assets/logo.png" alt="湖南新华" class="logo" />
          <h1 class="title">湖南新华</h1>
        </div>
        <div class="time-section">
          <div class="current-time">{{ currentTime }}</div>
        </div>
      </div>
    </header>

    <!-- 临时提示：条件为 true 时显示 -->
    <div v-if="showBrowserHint" class="browser-hint">请在电脑浏览器端打开页面</div>

    <!-- 主要内容区域 - 小屏移动端紧凑单栏布局 -->
    <main class="screen-main">
      <div class="modules-container">
        <!-- 今日销售 - 优先显示 -->
        <div class="module-container priority">
          <TodaySales />
        </div>

        <!-- 核心数据模块组 -->
        <div class="module-row compact">
          <div class="module-container mini">
            <BookStatistics />
          </div>
          <div class="module-container mini">
            <TextbookStatistics />
          </div>
        </div>

        <!-- 湖南地图 - 紧凑版 -->
        <div class="module-container map-container">
          <HunanMap />
        </div>

        <!-- 销售数据模块组 -->
        <div class="module-row compact">
          <div class="module-container mini">
            <ChannelSales />
          </div>
          <div class="module-container mini">
            <OrderComparison />
          </div>
        </div>

        <!-- 会员趋势 -->
        <div class="module-container">
          <MemberTrend />
        </div>

        <!-- 分类对比模块组 -->
        <div class="module-row compact">
          <div class="module-container mini">
            <SalesCategory />
          </div>
          <div class="module-container mini">
            <CityChannelComparison />
          </div>
        </div>
      </div>
    </main>

    <!-- 加载遮罩 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner">
        <div class="spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BookStatistics from '@/components/Modules/BookStatistics.vue'
import ChannelSales from '@/components/Modules/ChannelSales.vue'
import SalesCategory from '@/components/Modules/SalesCategory.vue'
import TodaySales from '@/components/Modules/TodaySales.vue'
import HunanMap from '@/components/Modules/HunanMap.vue'
import MemberTrend from '@/components/Modules/MemberTrend.vue'
import TextbookStatistics from '@/components/Modules/TextbookStatistics.vue'
import OrderComparison from '@/components/Modules/OrderComparison.vue'
import CityChannelComparison from '@/components/Modules/CityChannelComparison.vue'

export default {
  name: 'MobileSmallLayout',
  components: {
    BookStatistics,
    ChannelSales,
    SalesCategory,
    TodaySales,
    HunanMap,
    MemberTrend,
    TextbookStatistics,
    OrderComparison,
    CityChannelComparison
  },
  props: {
    currentTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showBrowserHint: true
    }
  },
  computed: {
    ...mapState(['loading', 'lastUpdateTime'])
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.mobile-small-layout {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(135deg, #0c1426 0%, #1a2332 50%, #0c1426 100%);
  color: #ffffff;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  position: relative;

  .browser-hint {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000000;
    background: #fff;
    color: #ff9a57;
    font-size: 16px;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 头部样式 - 更紧凑
  .screen-header {
    height: 50px;
    background: linear-gradient(90deg, rgba(24, 144, 255, 0.1) 0%, rgba(24, 144, 255, 0.05) 100%);
    border-bottom: 1px solid rgba(24, 144, 255, 0.3);
    display: flex;
    align-items: center;
    padding: 0 15px;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 100;

    .header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo-section {
        display: flex;
        align-items: center;
        gap: 8px;

        .logo {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }

        .title {
          font-size: 14px;
          font-weight: bold;
          background: linear-gradient(45deg, #1890ff, #52c41a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin: 0;
          text-shadow: 0 0 15px rgba(24, 144, 255, 0.5);
          white-space: nowrap;
        }
      }

      .time-section {
        text-align: right;

        .current-time {
          font-size: 12px;
          font-weight: bold;
          color: #1890ff;
          text-shadow: 0 0 8px rgba(24, 144, 255, 0.5);
        }
      }
    }
  }

  // 主要内容区域 - 小屏移动端紧凑单栏布局
  .screen-main {
    padding: 10px;

    .modules-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .module-container {
      background: linear-gradient(135deg, rgba(24, 144, 255, 0.1) 0%, rgba(24, 144, 255, 0.05) 100%);
      border: 1px solid rgba(24, 144, 255, 0.3);
      border-radius: 4px;
      padding: 10px;
      backdrop-filter: blur(10px);
      box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
      min-height: 80px;
      overflow: hidden;

      &.priority {
        min-height: 70px;
        background: linear-gradient(135deg, rgba(24, 144, 255, 0.15) 0%, rgba(24, 144, 255, 0.08) 100%);
        border: 2px solid rgba(24, 144, 255, 0.4);
      }

      &.map-container {
        min-height: 180px;
      }

      &.mini {
        flex: 1;
        min-height: 70px;
        padding: 8px;
      }
    }

    .module-row {
      display: flex;
      gap: 10px;

      &.compact {
        gap: 8px;
      }

      .module-container {
        margin: 0;
      }
    }
  }

  // 加载遮罩样式
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .loading-spinner {
      text-align: center;

      .spinner {
        width: 30px;
        height: 30px;
        border: 2px solid rgba(24, 144, 255, 0.3);
        border-top: 2px solid #1890ff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 10px;
      }

      .loading-text {
        color: #1890ff;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  // 超小屏幕优化
  @media screen and (max-width: 350px) {
    .screen-header {
      height: 45px;
      padding: 0 12px;

      .header-content {
        .logo-section {
          gap: 6px;

          .logo {
            width: 20px;
            height: 20px;
          }

          .title {
            font-size: 12px;
          }
        }

        .time-section {
          .current-time {
            font-size: 11px;
          }
        }
      }
    }

    .screen-main {
      padding: 8px;

      .modules-container {
        gap: 8px;
      }

      .module-container {
        padding: 8px;
        min-height: 70px;

        &.map-container {
          min-height: 150px;
        }

        &.mini {
          min-height: 60px;
          padding: 6px;
        }
      }

      .module-row {
        gap: 6px;

        &.compact {
          gap: 5px;
        }
      }
    }
  }

  // 横屏适配 - 极度紧凑
  @media screen and (orientation: landscape) and (max-height: 400px) {
    .screen-header {
      height: 40px;
    }

    .screen-main {
      .module-container {
        min-height: 60px;

        &.map-container {
          min-height: 120px;
        }

        &.mini {
          min-height: 50px;
        }
      }
    }
  }
}
</style>